import PaginateButton from "../../../../shared/PaginateButton/PaginateButton";
import {  setSubadminCurrentPage, } from "../../../../store/features/AdminPanel/SubAdmin/SubAdminSlice";
import {
  RootStore,
  useAppDispatch,
  useAppSelector,
} from "../../../../store/store";
import "./index.scss";

const SubAdminFooter = () => {
  const dispatch = useAppDispatch();
  const userState: any = useAppSelector((store: RootStore) => {
    return store.SubAdminSlice;
  });
  const handlePagination = (num: number) => {
    // dispatch(subAdminPaginate(num));
    dispatch(setSubadminCurrentPage(num+1));
  };
  return (
    <div className="mentor__pagination__section">
      <PaginateButton
        paginate={handlePagination}
        totalRows={userState.pagination_data?.total}
      />
    </div>
  );
};

export default SubAdminFooter;
